<template>
    <div class="container">
        <div class="content">
            <div class="breadcrumb">
                <a @click="$router.go(-1)">小程序管理</a>
                <i>/</i>
                <span>{{ title }}</span>
            </div>
            <div class="form">
                <!--        <div class="formItem">-->
                <!--          <div>-->
                <!--            标题-->
                <!--          </div>-->
                <!--          <div class="inputBox">-->
                <!--            <input type="text" v-model="title" />-->
                <!--          </div>-->
                <!--        </div>-->
                <div class="formItem editorBox" v-if="title !== '公司地址及电话'">
                    <div>
                        正文
                    </div>
                    <div class="editor">
                        <!-- <editor :init="init" v-model="editorContent"></editor> -->
                        <tinymceEditor v-model="editorContent"></tinymceEditor>
                    </div>
                </div>
                <div class="companyInfo" v-else>
                    <div class="formItem">
                        <div>
                            地址
                        </div>
                        <div class="inputBox">
                            <input type="text" v-model="addr" />
                        </div>
                    </div>
                    <div class="formItem">
                        <div>
                            电话
                        </div>
                        <div class="inputBox">
                            <input type="text" v-model="tel" />
                        </div>
                    </div>
                </div>
                <div class="formBtns">
                    <button class="btn_primary" @click="submit">保存</button>
                    <button class="btn_primary" @click="cancel">取消</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import comSelect from "../../components/comSelect";
import comMsg from "../../components/comMsg";
import tinymceEditor from "../../components/tinymceEditor";
import { getAllDoc, updateUserAgreement, updatePrivacyPolicy, updateHelp, updateCompanyInfo, updateTip } from "@/http/management";

export default {
    components: {
        comSelect,
        comMsg,
        tinymceEditor,
    },
    data() {
        return {
            title: "",
            item: {},
            editorContent: "",
            addr: "",
            tel: "",
        };
    },
    methods: {
        cancel() {
            this.$router.go(-1);
        },
        submit() {
            if (this.title !== "公司地址及电话") {
                if (this.title === "") {
                    layer.msg("请输入主标题");
                    return;
                }
                if (this.editorContent === "") {
                    layer.msg("请输入正文");
                    return;
                }
            } else {
                if (this.addr === "") {
                    layer.msg("请输入地址");
                    return;
                }
                if (this.tel === "") {
                    layer.msg("请输入电话");
                    return;
                }
            }
            this.save();
        },
        save() {
            if (this.title === "搜索不到设备") {
                // console.log(this.item)
                updateTip({
                    content: this.editorContent,
                })
                    .then((res) => {
                        console.log(res);
                        if (res.data.errCode === 0) {
                            layer.msg("成功");
                            setTimeout(() => {
                                this.$router.go(-1);
                            }, 100);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            } else if (this.title === "用户协议") {
                updateUserAgreement({
                    content: this.editorContent,
                })
                    .then((res) => {
                        console.log(res);
                        if (res.data.errCode === 0) {
                            layer.msg("成功");
                            setTimeout(() => {
                                this.$router.go(-1);
                            }, 100);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            } else if (this.title === "隐私协议") {
                updatePrivacyPolicy({
                    content: this.editorContent,
                })
                    .then((res) => {
                        console.log(res);
                        if (res.data.errCode === 0) {
                            layer.msg("成功");
                            setTimeout(() => {
                                this.$router.go(-1);
                            }, 100);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            } else if (this.title === "使用帮助") {
                updateHelp({
                    content: this.editorContent,
                })
                    .then((res) => {
                        console.log(res);
                        if (res.data.errCode === 0) {
                            layer.msg("成功");
                            setTimeout(() => {
                                this.$router.go(-1);
                            }, 100);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            } else if (this.title === "公司地址及电话") {
                console.log(this.item);
                let companyInfo = {
                    name: "深圳市攀高电子",
                    telephone: this.tel,
                    address: this.addr,
                    latitude: "22.608741",
                    longitude: "114.217090",
                };
                updateCompanyInfo(companyInfo)
                    .then((res) => {
                        console.log(res);
                        if (res.data.errCode === 0) {
                            layer.msg("成功");
                            setTimeout(() => {
                                this.$router.go(-1);
                            }, 100);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            }
        },
    },
    created() {
        let data = this.$route.query;
        console.log(data);
        this.title = data.title;
        this.item = data.item;
        if (this.item.content) {
            this.editorContent = this.item.content;
        }
        if (this.item.address) {
            this.addr = this.item.address;
        }
        if (this.item.telephone) {
            this.tel = this.item.telephone;
        }
    },
};
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    min-height: 800px;
    display: flex;
    justify-content: center;
    position: relative;
    padding-top: 40px;
}
.breadcrumb {
    position: absolute;
    top: 0px;
    left: 0px;
    font-size: 20px;
    a {
        font-weight: 550;
        color: #3c3c3c;
    }
}
.form {
    .companyInfo {
        padding-top: 100px;
        .formItem {
            width: 80%;
            padding-bottom: 40px;
        }
    }
}
.inputBox {
    flex: 1;
    input {
        width: 100%;
        height: 30px;
        padding: 0% 10px;
        font-size: 16px;
        &:disabled {
            background: #fff;
            border: 1px solid #ddd;
        }
    }
    span {
        padding-left: 10px;
        color: #808080;
    }
}

.editor {
    flex: 1;
}
.editorBox {
    align-items: flex-start;
    margin-left: -80px;
}
</style>
